/* Page to fetch all Callsheets data and render the display info
 * Contains the CallsheetTop component to which it passes the data 
   for each Callsheet cover */
import React, {
  useCallback,
  useEffect,
  useState,
} from "react";

import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { axiosInstance } from "../../api/axiosDefaults";
import { useRedirect } from "../../hooks/Redirect";
import TopBox from "../../components/TopBox";
import { useCurrentUser } from "../../contexts/CurrentUserContext";
import EpisodeList from "../episodes/EpisodeList";
import btnStyles from "../../styles/Button.module.css";
import styles from "../../styles/Callsheets.module.css";

const CallsheetsPageEpisode = ({ filter = "" }) => {
  useRedirect();
  const [episodes, setEpisodes] = useState([]);
  const history = useHistory();
  const currentUser = useCurrentUser();
  const queryString = window.location.search;
  const callEpi = true;
  // Television
  // eslint-disable-next-line
  const projectType =
    currentUser?.project_category_type &&
    JSON.parse(currentUser.project_category_type);

  // Use URLSearchParams to parse the query string
  // eslint-disable-next-line
  const params = new URLSearchParams(queryString);

  const fetchEpisodes = async () => {
    try {
      const { data } = await axiosInstance.get(
        `${localStorage.getItem("projectSlug")}/scene_episodes/`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          withCredentials: true,
        }
      );

      setEpisodes(data.results);
      // setProjectId(data.project);
    } catch (error) {
      console.log("fetch series error: ", error);
    }
  };

  useEffect(() => {
    fetchEpisodes();
  }, []);

  const getLink = useCallback((episode) => {
    // Add null/undefined check for episode
    if (!episode) return "/";

    return `/${localStorage.getItem("projectSlug")}/callsheets?episode=${
      episode.id
    }&project=${episode.project}&episodeTitle=${encodeURIComponent(
      episode.episode_number
    )}`;
  }, []);

  return (
    <div>
      <TopBox work="Callsheets" />
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} py-0 mt-1`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <h3 className="text-center my-3">Select Episode</h3>
      <hr className={`mt-0 mb-0 py-1 ${styles.BreakTitle}`}/>
      <EpisodeList
        callEpi={callEpi}
        currentUser={currentUser}
        episodes={episodes}
        getLink={getLink}
      />
    </div>
  );
};

export default CallsheetsPageEpisode;
